import { useStaticFlagsHookQuery } from './graphql.v3.generated';

export const useStaticFlags = () => {
  const { data } = useStaticFlagsHookQuery();

  if (!data?.staticFlags) {
    return null;
  }

  return data.staticFlags;
};
